import { useState, useCallback } from 'react';
import { toast } from 'sonner';

export const useAsyncState = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAsyncOperation = useCallback(async <T = void>(
    operation: () => Promise<T>,
    errorMessage: string = 'Ocorreu um erro na operação'
  ): Promise<T | undefined> => {
    setLoading(true);
    setError(null);

    try {
      const result = await operation();
      return result;
    } catch (err) {
      console.error(err);
      setError(err instanceof Error ? err.message : errorMessage);
      return undefined;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    handleAsyncOperation
  };
}; 